module.exports = __webpack_public_path__ + "img/tablo_hover_47bdad8.webp";